<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
          信息化产品
        </div>
        <div class="txt">
          morematization Products
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/p31.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">基于人工智能的电系操作指令票自动识别</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            操作票为操作人员停复役提供依据，当需要完成大量的操作任务时，工作人员需要反复
            填写与核对，容易产生疲劳，提高失误率；基于人工智能的电系操作指令票自动识别系
            统，通过OCR识别技术，将纸质的电系操作指令票转换为数字流，获取到电系操作指令
            票数据流后，设计一种基于电系操作指令票特定格式的逻辑算法，以此逻辑将任务内容
            拆解为各项工作步骤，然后分类提取出其中关键的步骤，并给出完成方案。最后通过人
            为设定好的数据自动完成工作，如自动生成相应的操作票。此方法可以大大减少人为的
            重复性机械化活动，避免因人员重复劳动造成失误的情况，节省劳动力，提高工作效率。
          </div>
          <div class="title">相关案例</div>
          <div class="introimg">
             <img src='../assets/p32.png' alt="">
             <div class="intro" @click="gotoDetail">
              <span class="el-icon-right" ></span>
             </div>
          </div>
          
          <div class="txt last">基于人工智能的电系操作指令票自动识别</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list">
            <div class="title">OCR表格识别	</div>
            <div class="en">OCR Form Recognition</div>
            <div class="txt"><span class="el-icon-caret-right"></span>使用OCR表格识别技术，对电系操作指令票
的图像进行处理生成所对应excel文件。</div>
            
          </div> 
          <div class="more_list">
            <div class="title">POI技术</div>
            <div class="en">POI technology</div>
            <div class="txt"><span class="el-icon-caret-right"></span>使用POI技术读取excel文件，获取每个单元
格中的内容。还可以对word文档中的关键字
进行字符替换，生成新的文档。</div>
          </div>
          <div class="more_list end">
            <div class="title">算法处理	</div>
            <div class="en">Algorithm processing</div>
            <div class="txt"><span class="el-icon-caret-right"></span>针对于电系操作指令票的特殊格式，对数据
处理上不能通用处理，使用一套针对于此格
式的处理逻辑，能够更加准确的进行数据匹
配，提升准确率。</div>
          </div>
          
        </div>
        <div class="more_bottom">
          <div class="more_list">
            <div class="title">跨平台性</div>
            <div class="en">Cross-platform</div>
            <div class="txt"><span class="el-icon-caret-right"></span>本系统使用Java语言进行开发，架设在web
网页上，具有很好的跨平台性和可扩展性。</div>
          </div> 
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code.png" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail3')
    }
  }
}
</script>
<style scoped>
.introimg{
  display: flex;
    align-items: center;
}
.intro {
  text-align: center;
  width: 75px;
  height: 35px;
  line-height: 35px;
  background: #f5a93e;
  border-radius: 4px 4px 4px 4px;
  color: #FFFFFF ;
  margin-left: 30px;
  /* margin: 0 auto; */
  }
.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 280px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 550px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  /* height: 200px; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;
}
.more_detail .end {
  margin-right: 0;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;


}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor2.vue